import { forwardRef, useImperativeHandle, useState, useMemo } from 'react';
import { Form, message, Modal, Upload, Button, Image } from "antd";
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import { useRequest } from "ahooks";
import { EditForm, FormConfigType } from "../../../components/editForm";
import { langCommon, langPage } from "../../../locales";
import { SettingsServer, CommonServer } from "../../../server";
import { generateOperationFormConfig, DEFAULT_OPERATION_DATA } from './config';

const server = SettingsServer.Banner
const commonServer = CommonServer.Common

const lang = langPage?.member?.user;


type OperateModeType = 'create' | 'modify'


export const Operation = forwardRef((props: any, ref: any) => {
    const { onSuccess } = props;
    const [loading, setLoading] = useState<boolean>(false);
    const [uploadLoading, setUploadLoading] = useState<boolean>(false);
    const [visible, setVisiable] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({ ...DEFAULT_OPERATION_DATA });
    const [form] = Form.useForm();
    const [mode, setMode] = useState<OperateModeType>('create');
    const [imageUrl, setImageUrl] = useState<string>('');

    useImperativeHandle(ref, () => ({
        changeVisible
    }))

    const changeVisible = (val: any, mode?: OperateModeType) => {
        console.log(val)
        if (val) {
            const data = {
                ...DEFAULT_OPERATION_DATA,
                ...(mode === 'modify' ? val : {})
            };
            mode && setMode(mode)
            form?.resetFields?.();
            setFormData(data);
            setImageUrl(val?.Image)
        } else if (val) {
            form?.resetFields?.();
        }
        setVisiable(!!val);
    }
    // 新增
    const { run } = useRequest(mode === 'create' ? server.create : server.modify, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => changeVisible(false),
        onSuccess: (res: any) => {
            message.success(mode === 'create' ? langCommon?.createSuccess : langCommon?.modifySuccess);
            onSuccess?.();
            changeVisible(false);
        }
    });

    const getBaseInfoFormConfig: FormConfigType = useMemo((): FormConfigType => {
        return generateOperationFormConfig({ formData, mode });
    }, [formData, mode]);

    const customRequest = async (options: any) => {
        const { file } = options; // 这里使用解构     
        const formData = new FormData();
        formData.append('File', file);
        try {
            const res = await commonServer.uploadFile(formData);
            console.log(res)
            setImageUrl(res)
        } catch (err) {
            console.log('err', err)
        } finally {
            setUploadLoading(false);
        }
    };
    return (
        <div>
            <Modal
                title={`${mode === 'create' ? langCommon?.create : langCommon?.modify}轮播图`}
                width={500}
                closeIcon={null}
                maskClosable={false}
                open={visible}
                onCancel={() => changeVisible(false)}
                okButtonProps={{ loading }}
                onOk={async () => {
                    await form.validateFields();
                    const { Link, Style, Id, Sort, Status, Title, Image, Position } = formData
                    const params = {
                        Link, Style, Id, Sort, Status, Title, Position, Image: imageUrl
                    }
                    if (!imageUrl) { 
                        message.error("请上传图片")
                        return
                    }
                    run(params)
                }}
            >   

                <EditForm
                    componentId="config-operation"
                    className="mt20"
                    form={form}
                    formAttrsProps={{
                        labelCol: { span: 6 },
                        wrapperCol: { span: 18 },
                    }}
                    formData={formData}
                    onDataChange={(data: any) => {
                        setFormData(data);
                    }}
                    formConfig={getBaseInfoFormConfig}
                />
                <div className="flex space-start ml42">
                    <span className="red">*</span>
                    <span className="mr10">上传图片:</span>
                    
                    <div className="flex flex-column">
                        <Upload
                            customRequest={customRequest}
                            maxCount={1}
                            showUploadList={false}
                        >
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                        {imageUrl && <Image className="mt10" src={imageUrl.includes("http") ? imageUrl : `${window.location.origin}${imageUrl}`} width={150}/>}
                    </div>
                </div>
            </Modal>
        </div>
    );
})
